module.exports = __webpack_public_path__ + "img/artboard18.2c36ffd3.png";